import { BRAND_LIST } from 'typings'
import * as Typings from '../typings'

const EuropeLocale: Typings.LocaleType = {
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'eu',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Europe',
  SHORT_NAME: 'EU',

  DISPLAY_NAME: 'Europe (English)',
  DISPLAY_COUNTRY: 'Europe',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 33.92920123358008,
    INITIAL_LONGITUDE: 138.42930714999994,
    INITIAL_ZOOM: 4,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {},

  HOME_PAGE_URL: 'https://www.uniqlo.com',

  MAP_URL: 'https://www.uniqlo.com/eu/en/content/store-locator.html',
  MAP_MOBILE_URL: 'https://map.uniqlo.com/eu/en/',

  TERMS_OF_USE_URL: 'https://www.uniqlo.com',
  PRIVACY_POLICY_URL: 'https://www.uniqlo.com',

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },
}

export default EuropeLocale
